import { useThemeStore } from "@/shared/stores/theme.store";
import { useEffect, type PropsWithChildren } from "react";

export function ThemeProvider({
    children,
}: PropsWithChildren){
    const theme = useThemeStore((state) => state.theme)

    useEffect(() => {
        document.documentElement.dataset.theme = theme
    }, [theme])

    return children
}